import useAccountInfo from "@/hooks/useAccountInfo";
import { useSidebarStore } from "@/stores/useSidebarStore";
import { cn } from "@/utils";
import { Divider } from "@heroui/react";
import { BillingButton } from "./BillingButton";
import { NotificationsButton } from "./NotificationsButton";
import { SupportChatToggle } from "./SupportChatToggle";
import { UserPopover } from "./UserPopover";

export const BottomFixedItems = () => {
  const sidebarOpen = useSidebarStore((state) => state.isOpen);

  const accountInfo = useAccountInfo((state) => state.accountInfo);
  const isIncognito = Boolean(accountInfo.superAdmin);

  return (
    <div
      className={cn(
        "bg-background/95 fixed bottom-0 z-50 hidden flex-col gap-1 rounded-4xl p-2 shadow-2xl backdrop-blur-md md:bottom-1 md:left-1 md:flex md:w-[52px]",
        "ease-lime-bezier-ease border-divider/60 border transition-all duration-200",
        {
          "flex w-full gap-1.5 rounded-t-2xl rounded-b-none pb-[calc(1.25rem_+_var(--safe-area-bottom,0px))] md:w-[262px] md:rounded-3xl md:pb-2":
            sidebarOpen,
          "outline-danger rounded-full outline-4": isIncognito,
        },
      )}
    >
      <div className="flex flex-col gap-1">
        <SupportChatToggle />
        <NotificationsButton />
        <BillingButton />
      </div>

      <Divider className="bg-divider/60 my-0.5" />

      <UserPopover />
    </div>
  );
};
